import General from "./Footer.general";
import ShoppingCart from "./Footer.shoppingCart";

export default {
  General,
  ShoppingCart
};
